import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import WalletDetailPage from 'src/components/views/Wallet/WalletDetailPage';

const mapStateToProps = ({ userState: { isAgent, isDomestic, userInfo } }: IStoreState) => ({
  isAgent,
  isDomestic,
  userInfo,
});

export default connect(mapStateToProps)(WalletDetailPage);


// WEBPACK FOOTER //
// ./src/containers/WalletDetail.ts